import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en';
import ru from './locales/ru';
import es from './locales/es';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
          //  en: { translation: en },
            ru: { translation: ru },
           // es: { translation: es },
        },
        fallbackLng: 'ru',  // язык по умолчанию

        supportedLngs: ['ru'/*,'en','es'*/],
        nonExplicitSupportedLngs: true,
        //debug: true,
        interpolation: {
            escapeValue: false,          // не экранируем для React
        },
        detection: {
            order: ['localStorage', 'navigator'],  // сначала localStorage, потом браузер
            caches: ['localStorage'],              // сохраняем выбор в localStorage
        },
        load: 'languageOnly',
    });

export default i18n;